import React, {  useState, useEffect ,useRef} from 'react';

import axios from 'axios';
import Modal from "./Modalxl";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useNavigate  } from "react-router-dom";
import CDashboard from "./ClientApplication/CLVehicleList";
import { useReactToPrint } from 'react-to-print';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const TechnicianDetails = () => 
{

  const fileType ="xlsx";
  const tableRef = useRef(null);
  const API_URL=aPIURL();
  const AUTH_URL= auTHURL();

  const [actionId , setActionId]= useState('1');
  const [custType ,setCustType] = useState(1);
  const [cstatusId ,setCstatusId] = useState('0');
  const [custID, setCustID] = useState('0');
  const [customerTypeId] = useState(0);

  const [stateId, setStateId]= useState( '');
  const [countryId, setCountryId]= useState('1');                                
  const [custGST ,setCustGST]= useState("");   
  const [dActionname, setDActionname]= useState('Save');
  const [cDisplay, setCDisplay]= useState('none');
 
  const [cNameLevel, setCNameLevel]= useState('Customer');           
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData]= useState([]);
  
  const [post, setPost] = useState([]);
  const [allPosts, setAllPosts] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10);
  //const [inputs, setInputs] = useState({});
const [inputs, setInputs] = useState({
    IsActive: true
});
  const [StatusData, setStatusData]= useState([]);
  const [customerData, setCustomerData]= useState([]);
  const [filteredCustomerDetails,setFilteredCustomerDetails]= useState([]);
  const [allotedDeviceByCustID, setAllotedDeviceByCustID]= useState([]);
  const [showAddDetails, setShowAddDetails]= useState(false);
  const [showDetails, setShowDetails]= useState(false);
  const [changePass, setChangePass]= useState(false);
  const [redioDispl, setRedioDispl]= useState(false);
  const [resetPassword,setResetPassword]  = useState('none');
  let [custTypeId, setCustTypeId]= useState(0);
  let [userMax, setUserMax]= useState(0);
  let [TechName , setTechName]= useState('');   
  let [TechMobile , setTechMobile]= useState('');   

  
 const navigate = useNavigate();

  useEffect(() => {
       
    const curls=API_URL+'countries';
    axios.post(curls).then(response => {                            
    setCountryData(response.data.data)
     }).catch(function(error){console.log(error.message);});
        
     const surls=API_URL+`states?Country_ID=1`;
     axios.post(surls).then(response => {                            
      setStateData(response.data.data)
       }).catch(function(error){console.log(error.message);});
    
    //grid binding start 
    FillGrid(0);    
    

  }, []);
  //Added Nitesh on 18 09 2026 for lat long using map
  useEffect(() =>
{
    const receiveLocation = (event) =>
    {
        if(event.data &&
            event.data.latitude &&
            event.data.longitude)
        {
            setInputs(values => ({
                ...values,
                Latitude: event.data.latitude,
                Longitude: event.data.longitude
            }));
        }
    };

    window.addEventListener("message", receiveLocation);

    return () =>
    {
        window.removeEventListener(
            "message",
            receiveLocation
        );
    };

}, []);
  //End Nitesh on 18 09 2026
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);

const FillGrid = (Type_ID) =>
{
    const curls = API_URL + `TechnicianAllList?TypeID=${Type_ID}`;

    axios.post(curls)
    .then(response =>
    {
        console.log(response.data);

        setPost(response.data);
        setAllPosts(response.data);
    })
    .catch(function(error)
    {
        console.log(error.message);
    });
}

const ChangePage = ({ selected }) => {
       
        setNumber(selected+1);
};
//Start Nitesh on 18 09 2026 for Lat  using map
const openMap = () =>
{
    window.open(
        "/technicianmap.html",
        "TechnicianMap",
        "width=1200,height=800"
    );
};
const openTechnicianMap = () =>
{
    window.open(
        "/technicianmap.html?mode=viewall",
        "AllTechniciansMap",
        "width=1400,height=900"
    );
};
// End Nitesh on  18 09 2026
              
const showAddTechDetails=()=>
{
     setShowAddDetails(true);
     setShowDetails(false);

     setStateId('');
     setCountryId('1');

     setInputs({
        TechName: "",
        TechMobile: "",
        TechEmail: "",
        TechCity: "",
        TechPinCode: "",
        CustAddress: "",
        Latitude: "",
        Longitude: "",
        IsActive: true
     });
}

const closeAddCustomerModal = () => 
{
       setActionId('1'); 
       setDActionname('Save');
       setShowAddDetails(false);
       setShowDetails(false);  
       bindCustomerDetails();
       setInputs({});  
       //setChangePass(false);    
       
}  

const showDetailsModal = (index) =>
{
    const technicianId = index;

    const urls = API_URL + `GetTechnicianDetails/${technicianId}`;

    axios.post(urls)
    .then(response =>
    {
        setFilteredCustomerDetails(response.data);

        setShowDetails(true);
        setShowAddDetails(false);
    })
    .catch(function(error)
    {
        console.log(error.message);
        toast.error("Unable to load technician details.");
    });
}
const closeModal = () => {
     setShowDetails(false);
     setShowAddDetails(false); 
      
}
const sorting=(col)=>
{
  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            String(a[col]).toLowerCase() > String(b[col]).toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            String(a[col]).toLowerCase() < String(b[col]).toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }  
          
}
const bindCustomerDetails=()=>
{
      //grid binding start 
        FillGrid(custTypeId);
       //grid binding end       
}

const handleEdit = (index) =>
{
    const technicianId = index;

    const urls = API_URL + `GetTechnicianDetails/${technicianId}`;

    axios.post(urls)
    .then(response =>
    {
        const data = response.data[0];

        setActionId('2');
        setDActionname('Update');

        setCustID(data.technicianId);
        setCountryId(data.countryID);
        setStateId(data.stateID);

        setShowAddDetails(true);
        setShowDetails(false);

        setInputs({
            TechName: data.technicianName || "",
            TechMobile: data.mobileNumber || "",
            TechEmail: data.email || "",
            TechCity: data.city || "",
            TechPinCode: data.pinCode || "",
            CustAddress: data.address || "",
            Latitude: data.latitude || "",
            Longitude: data.longitude || "",
            IsActive: data.isActive === 1
        });
    })
    .catch(function(error)
    {
        console.log(error.message);
        toast.error("Unable to load technician details.");
    });
}

const handleDelete = (technicianId) =>
{
    if(!window.confirm("Are you sure you want to delete this technician?"))
    {
        return;
    }

    axios.post(
        API_URL + `TechnicianDelete/${technicianId}`
    )
    .then(function(response)
    {
        if(response.data.validStatus)
        {
            toast.success(response.data.message);

            // Refresh Grid
            FillGrid(custTypeId);
        }
        else
        {
            toast.error(response.data.message);
        }
    })
    .catch(function(error)
    {
        toast.error("Unable to delete technician.");

        console.log(error);
    });
}

const ChangeStateD = (e) => {

    setStateId(e.target.value);   

}
const ChangeCountryD = (e) => {

    setCountryId(e.target.value);
    if(actionId==="1") // && (inputs.CustUserMax==='' || (!inputs.CustUserMax)))
    {
           setUserMax(0);
      //inputs.CustUserMax=0;
    }
  }
const changeHandler = (event) => {

  if(event.target.name === 'TechMobile')
  {
    const re = /^[0-9\b]+$/;

    if (event.target.value === '' || re.test(event.target.value)) 
    {
      const name = event.target.name;
      const value = event.target.value;

      setInputs(values => ({...values, [name]: value}));
    }
    else
    {
      setInputs(values => ({...values, ['TechMobile']: ""}));
    }
  }

  else if(event.target.name === 'TechPinCode')
  {
    const re1 = /^[0-9\b]+$/;

    if (event.target.value === '' || re1.test(event.target.value)) 
    {
      const name = event.target.name;
      const value = event.target.value;

      setInputs(values => ({...values, [name]: value}));
    }
    else
    {
      setInputs(values => ({...values, ['TechPinCode']: ""}));
    }
  }

  else if(event.target.name === 'ContactNumber')
  {
    const re2 = /^[0-9\b]+$/;

    if (event.target.value === '' || re2.test(event.target.value)) 
    {
      const name = event.target.name;
      const value = event.target.value;

      setInputs(values => ({...values, [name]: value}));
    }
    else
    {
      setInputs(values => ({...values, ['ContactNumber']: ""}));
    }
  }

  else if(
  event.target.name === 'Latitude' ||
  event.target.name === 'Longitude'
)
{
  // Allow numbers, one decimal point and optional minus sign at the beginning
  const re = /^-?\d*\.?\d*$/;

  if (event.target.value === '' || re.test(event.target.value))
  {
    const name = event.target.name;
    const value = event.target.value;

    setInputs(values => ({
      ...values,
      [name]: value
    }));
  }
}
  else
  {
    const name = event.target.name;
    const value = event.target.value;

    setInputs(values => ({...values, [name]: value}));
  }
}
            
const onClickRegister = () => {  
    if(!inputs.TechName )  
  {
    toast.error(" Technician Name is required.");
    return;
   }
  else if(inputs.TechName==='' )
  {
    toast.error("Technician Name is required.");
     return;
  }
  
  else if(!inputs.TechMobile)
{
    toast.error("Technician mobile number is required.");
    return;
}
else if(inputs.TechMobile === '')
{
    toast.error("Technician mobile number is required.");
    return;
}
else if(inputs.TechMobile.length !== 10)
{
    toast.error("Technician mobile number should be 10 digits.");
    return;
}

else if(
    inputs.TechEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputs.TechEmail))
{
    toast.error("Technician email is invalid.");
    return;
}
  else if(!countryId)
  {
        toast.error("Country is required.");
        return;
  }
  else if(countryId==='')
  {
         toast.error("Country is required.");
         return;
  }
  else if(!stateId)
  {
         toast.error("State is required.");
         return;
  }
  else if(stateId==='')
  {
         toast.error("State is required.");
         return;
  }
  else if(!inputs.TechCity)
  {
       toast.error("City is required.");
       return;
  }
  else if(inputs.TechCity==='')
  {
        toast.error("City is required.");
        return;
  }

  else if(!inputs.Latitude)
{
    toast.error("Latitude is required.");
    return;
}
else if(!inputs.Latitude.trim())
{
    toast.error("Latitude is required.");
    return;
}
else if(!/^-?\d+(\.\d+)?$/.test(inputs.Latitude))
{
    toast.error("Latitude must contain only numbers, decimal point and optional minus sign.");
    return;
}
else if(!inputs.Longitude)
{
    toast.error("Longitude is required.");
    return;
}
else if(!inputs.Longitude.trim())
{
    toast.error("Longitude is required.");
    return;
}
else if(!/^-?\d+(\.\d+)?$/.test(inputs.Longitude))
{
    toast.error("Longitude must contain only numbers, decimal point and optional minus sign.");
    return;
}
  else if(!inputs.TechPinCode)
  {
        toast.error("Pincode is required.");
       
       return;
  }
  else if(inputs.TechPinCode==='')
  {
        toast.error("Pincode is required.");
        return;
  }  
  
 else  
{
 
 if(actionId==='1')
 {
   
      //alert(userparams);
     //Insert Technician Details
     const params = JSON.stringify({

    "technicianId": 0,
    "technicianName": inputs.TechName,
    "mobileNumber": inputs.TechMobile,
    "email": inputs.TechEmail,
    "countryID": parseInt(countryId),
    "stateID": parseInt(stateId),
    "city": inputs.TechCity,
    "latitude": inputs.Latitude,
    "longitude": inputs.Longitude,
    "pinCode": inputs.TechPinCode,
    "address": inputs.CustAddress,
    "isActive": inputs.IsActive ? 1 : 0,
    "createdBy": "Admin"

});
     
    const API_URL=aPIURL();
    //User Registration start
    //alert(AUTH_URL+'Register');
    axios.post(API_URL + 'TechnicianInsert', params, {

    headers:
    {
        "content-type": "application/json",
    }
})
.then(function (response)
{
    if(response.data.validStatus)
    {
        toast.success(response.data.message);

        handleAddCustomerClear();
    }
    else
    {
        toast.error(response.data.message);
    }
})
.catch(function (error)
{
    toast.error("Error while saving Technician.");
    console.log(error);
});

    //user Registration ends     
  } 
  else
  {
       
     const params = JSON.stringify({

    "technicianId": custID,
    "technicianName": inputs.TechName,
    "mobileNumber": inputs.TechMobile,
    "email": inputs.TechEmail,
    "countryID": parseInt(countryId),
    "stateID": parseInt(stateId),
    "city": inputs.TechCity,
    "latitude": inputs.Latitude,
    "longitude": inputs.Longitude,
    "pinCode": inputs.TechPinCode,
    "address": inputs.CustAddress,
    "isActive": inputs.IsActive ? 1 : 0,
    "createdBy": "Admin"

});

     axios.post(API_URL +'TechnicianEdit', params, {
         "headers": 
         {
                "content-type": "application/json",    
         },

    })
      .then(function (response) 
      {
        if(!response.data.validStatus)
        {
                 toast.error(response.data.message);
                 //return;
        }
        else
        {
              
              toast.success(response.data.message);
              console.log(response.data);
        }                       
           
      })

      .catch(function (error) 
      {
            
            toast.error("Some Error occured while saving Technician record, Please Provide valid Inputs");
            console.log(error);    
      });
        //console.log(this.state);
        handleUpdateCustomerClear();
                  
  }
}
    }
   
const handleAddCustomerClear = () =>
{
    setInputs({
        TechName: "",
        TechMobile: "",
        TechEmail: "",
        TechCity: "",
        TechPinCode: "",
        CustAddress: "",
        Latitude: "",
        Longitude: "",
        IsActive: true
    });

    setCustID('0');
    setActionId('1');
    setDActionname('Save');

    setStateId('');
    setCountryId('1');
    
    bindCustomerDetails();
}
  const handleUpdateCustomerClear=()=>
  {
       //bind device details grid
       bindCustomerDetails();        
  }
  const exportStatus = e => {
    const value = e.target.value;
    setCustTypeId(e.target.value);
    FillGrid(value);
  }
const TechNamechangeHandler=(e)=>
{
      setTechName(e.target.value)
}
const TechMobilechangeHandler=(e)=>
{
     const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value))
        {
             setTechMobile(e.target.value)
        }
        else
        {
           setTechMobile('');
        }
}

const FilterGrid = () =>
{
    const filteredData = allPosts.filter(item =>
    {
        const nameMatch =
            !TechName ||
            item.technicianName
                .toLowerCase()
                .includes(TechName.toLowerCase());

        const mobileMatch =
            !TechMobile ||
            String(item.mobileNumber)
                .includes(TechMobile);

        return nameMatch && mobileMatch;
    });

    setPost(filteredData);

    setNumber(1);
}
const ResetList = () =>
{
    setTechName("");
    setTechMobile("");

    setPost(allPosts);

    setNumber(1);
}
  const exportToCSV = () =>
{
    const exportData = post.map((item, index) => ({
        "S.No.": index + 1,
        "Technician Name": item.technicianName,
        "Mobile Number": item.mobileNumber,
        "Email": item.email,
        "Country": item.countryName,
        "State": item.stateName,
        "City": item.city,
        "Latitude": item.latitude,
        "Longitude": item.longitude,
        "Address": item.address,
        "PinCode": item.pinCode,
        "Status": item.isActive === 1 ? "Active" : "Inactive"
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);

    const wscols = [
        { wch: 8 },   // S.No
        { wch: 30 },  // Technician Name
        { wch: 18 },  // Mobile
        { wch: 30 },  // Email
        { wch: 20 },  // Country
        { wch: 20 },  // State
        { wch: 20 },  // City
        { wch: 15 },  // Latitude
        { wch: 15 },  // Longitude
        { wch: 40 },  // Address
        { wch: 15 },  // PinCode
        { wch: 12 }   // Status
    ];

    ws['!cols'] = wscols;

    const wb = {
        Sheets: { Technicians: ws },
        SheetNames: ["Technicians"]
    };

    const excelBuffer = XLSX.write(
        wb,
        {
            bookType: "xlsx",
            type: "array"
        }
    );

    const data = new Blob(
        [excelBuffer],
        {
            type: fileType
        }
    );

    FileSaver.saveAs(
        data,
        "TechnicianDetails.xlsx"
    );
};
// Start Import to excel
const validateTechnicianRow = (row, rowNo) => {
    const errors = [];
    const name = String(row.TechnicianName).trim();
    const mobile = String(row.MobileNumber).trim();
    const email = String(row.Email).trim();
    const country = Number(row.CountryID);
    const state = Number(row.StateID);
    const city = String(row.City).trim();
    const pin = String(row.PinCode).trim();

    if (!name) errors.push(`Row ${rowNo}: TechnicianName is required`);
    if (!/^\d{10}$/.test(mobile))
        errors.push(`Row ${rowNo}: MobileNumber must be 10 digits`);
    if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email))
        errors.push(`Row ${rowNo}: Invalid Email`);
    if (!Number.isInteger(country) || country <= 0)
        errors.push(`Row ${rowNo}: Invalid CountryID`);
    if (!Number.isInteger(state) || state <= 0)
        errors.push(`Row ${rowNo}: Invalid StateID`);
    if (!city) errors.push(`Row ${rowNo}: City is required`);
    if (!/^\d{6}$/.test(pin))
        errors.push(`Row ${rowNo}: PinCode must be 6 digits`);

    return errors;
};


const handleExcelImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reset = () => event.target.value = "";

    if (!/\.(xlsx|xls)$/i.test(file.name)) {
        toast.error("Please select a valid Excel file.");
        return reset();
    }

    const reader = new FileReader();

    reader.onload = (e) => {
        try {
            const workbook = XLSX.read(e.target.result, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            if (!sheet) {
                toast.error("Invalid Excel file.");
                return reset();
            }

            const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            if (!rows.length) {
                toast.error("Excel file is empty.");
                return reset();
            }

            const required = ["TechnicianName", "MobileNumber", "Email","CountryID", "StateID", "City", "Latitude","Longitude", "PinCode", "Address", "IsActive", "CreatedBy" ];
            const missing = required.filter(
                col => !Object.keys(rows[0]).includes(col)
            );
            if (missing.length) {
                toast.error(`Missing columns: ${missing.join(", ")}`);
                return reset();
            }

            const errors = rows.flatMap((row, i) =>
                validateTechnicianRow(row, i + 2)
            );

            if (errors.length) {
                console.error(errors);
                toast.error(`Excel validation failed: ${errors.length} error(s).`);
                return reset();
            }

            const excelData = rows.map(row => ({
                TechnicianName: String(row.TechnicianName).trim(),
                MobileNumber: String(row.MobileNumber).trim(),
                Email: String(row.Email).trim(),
                CountryID: Number(row.CountryID),
                StateID: Number(row.StateID),
                City: String(row.City).trim(),
                Latitude: String(row.Latitude).trim(),
                Longitude: String(row.Longitude).trim(),
                PinCode: String(row.PinCode).trim(),
                Address: String(row.Address).trim(),
                IsActive: Number(row.IsActive || 0),
                CreatedBy: String(row.CreatedBy).trim() || "Admin"
            }));

            importTechnicians(excelData);

        } catch (error) {
            console.error(error);
            toast.error("Unable to read Excel file.");
        } finally {
            reset();
        }
    };

    reader.onerror = () => {
        toast.error("Unable to read Excel file.");
        reset();
    };

    reader.readAsArrayBuffer(file);
};


const importTechnicians = (excelData) => {
    axios.post(
        API_URL + "TechnicianBulkInsert",
        excelData,
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
    .then(({ data }) => {
        if (data.validStatus) {
            toast.success(data.message);
            FillGrid(0);
        } else {
            toast.error(data.message);
        }
    })
    .catch((error) => {
        console.error(error);
        toast.error("Error importing technician data.");
    });
};

const downloadSampleExcel = () => {

    const sampleData = [
        {
            TechnicianName: "John Doe",
            MobileNumber: "9876543210",
            Email: "john@example.com",
            CountryID: 1,
            StateID: 1,
            City: "Delhi",
            Latitude: "28.6139",
            Longitude: "77.2090",
            PinCode: "110001",
            Address: "Sample Address",
            IsActive: 1,
            CreatedBy: "Admin"
        }
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData);

    const wscols = [
        { wch: 25 }, // TechnicianName
        { wch: 18 }, // MobileNumber
        { wch: 30 }, // Email
        { wch: 12 }, // CountryID
        { wch: 12 }, // StateID
        { wch: 20 }, // City
        { wch: 15 }, // Latitude
        { wch: 15 }, // Longitude
        { wch: 12 }, // PinCode
        { wch: 35 }, // Address
        { wch: 12 }, // IsActive
        { wch: 15 }  // CreatedBy
    ];

    ws["!cols"] = wscols;

    const wb = {
        Sheets: {
            Technicians: ws
        },
        SheetNames: ["Technicians"]
    };

    const excelBuffer = XLSX.write(
        wb,
        {
            bookType: "xlsx",
            type: "array"
        }
    );

    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
    );

    FileSaver.saveAs( data, "TechnicianSample.xlsx" );
};

// End Import to excel

  const exportDownload = e => 
  {  
  
  const value = e.target.value; 
  //alert(value)
  
  if(value=="Excel")
  {
         exportToCSV();  
       //onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
  }
  
  const handlePrint = useReactToPrint({
  documentTitle: "Technician Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
  });
   
  return (
<>     

<Modal isOpen={showDetails} > 
      <div class="modal-header">
                <h5 className='modal-title'>Technician Details</h5>
                <button type="button" class="btn-close"  onClick={closeModal}></button>
                </div>
                <div class="modal-body">                        
                <div class="row">
                 <table >
                {filteredCustomerDetails.map(custdata1 => ( <tr key={custdata1.technicianId}>
                    <td>                    
                    <div class="row">                  
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;              
                    <b> Technician Name : </b>
                    {custdata1.technicianName}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Mobile Number : </b>        
                    {custdata1.mobileNumber}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Email : </b>       
                    {custdata1.email}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Country : </b>        
                    {custdata1.countryName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> State : </b>        
                    {custdata1.stateName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b>City : </b>      
                    {custdata1.city}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">
                     <b>Latitude : </b>
                     {custdata1.latitude}
                    </div>

                <div class="col-sm-6 col-md-4 form-group">
                <b>Longitude : </b>
                {custdata1.longitude}
                </div>  

                    <div class="col-sm-6 col-md-4 form-group">
                    <b>Address : </b>
                    {custdata1.address}
                    </div>

                    <div class="col-sm-6 col-md-4 form-group">
                    <b>Status : </b>
                    {custdata1.isActive === 1 ? "Active" : "Inactive"}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> PinCode : </b>        
                   {custdata1.pinCode}
                    </div>
               
               </div>               
                </td>                            
                </tr>
                 ))}
                </table>
                
               </div>
                </div>
</Modal>  
<Modal isOpen={showAddDetails} >  
 <div class="modal-header">
 <h5 className='modal-title'>Technician Details</h5>
 <button type="button" id="closeAddCustomerModal" class="btn-close" onClick={closeAddCustomerModal}></button>
 </div>
 <div class="modal-body"> 
 <div class="row">
 {/**/} 
 
 </div>        
<div class="row">
<div class="col-sm-4 col-md-4 form-group" >
Technician Name:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="TechName"  type="text" required="required"  className="form-control"  value={inputs.TechName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Website:
<input name="CustCompanyWebsite" type="text" required="required" className="form-control" value={inputs.CustCompanyWebsite} onChange={changeHandler} ></input>
</div>

<div class="col-sm-4 col-md-4 form-group">
Mobile Number:<span style={{color:"red"}}>&nbsp;*</span>
<input name="TechMobile" type="text" required="required" className="form-control" maxLength={10} value={inputs.TechMobile} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Email:
<input name="TechEmail" type="text" required="required" className="form-control" value={inputs.TechEmail} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Country:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control" name="DCountry" value={countryId} onChange={ChangeCountryD}  >
<option value="">Select Country</option>
{countryData.map((e, key) => {
return <option key={key} value={e.id}>{e.country_Name}</option>;
})}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
State:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control slct" name="DState" value={stateId} onChange={ChangeStateD} >
<option value="">Select State</option>
{stateData.map((e, key) => {
return <option key={key} value={e.id}>{e.state_Name}</option>;
})}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
City:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="TechCity"  type="text" required="required"  className="form-control"  value={inputs.TechCity} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Latitude:<span style={{color:"red"}}>&nbsp;*</span>
<input  name="Latitude"  type="text" required="required" className="form-control" value={inputs.Latitude || ""} onChange={changeHandler}/>
</div>

<div class="col-sm-4 col-md-4 form-group">
Longitude:<span style={{color:"red"}}>&nbsp;*</span>
<input
    name="Longitude"
    type="text"
    required="required"
    className="form-control"
    value={inputs.Longitude || ""}
    onChange={changeHandler}
/>
</div>

{/* Start Nitesh on 18 09 2026 Lat Long using map*/}
<div className="col-sm-4 col-md-4 form-group">
    <label>&nbsp;</label>
    <br />
    <button type="button" className="btn btn-primary" onClick={openMap} >
        Select Location
    </button>
</div>
{/* End Nitesh on 18 09 2026 */}

<div class="col-sm-4 col-md-4 form-group">
<label>Is Active</label>
<br />
<input
    type="checkbox" name="IsActive" checked={inputs.IsActive ?? false} onChange={(e) => setInputs(values => ({...values,IsActive: e.target.checked}))
    }
/>
</div>
<div class="col-sm-4 col-md-4 form-group">
PinCode:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="TechPinCode"  type="text" required="required"  maxLength={6} className="form-control" value={inputs.TechPinCode} onChange={changeHandler} ></input>
</div>

<div class="col-sm-4 col-md-4 form-group">
Address
<textarea name="CustAddress" type="text" className="form-control" value={inputs.CustAddress} onChange={changeHandler} rows={2} cols={20} />
 </div> 	
<div class="col-sm-4 col-md-4 form-group" style={{marginTop: "27px"}}>
</div>
<div class="col-sm-12 col-md-12 form-group">
 <center>
 <button type="submit" id="Save" onClick={onClickRegister} className="btn btn-primary2">{dActionname} </button>     
 </center>
 </div></div></div>
 </Modal>
 <div className="top-bar clearfix">
 <div className="row">
 <div className="col-md-4"><h2> Technician Details</h2></div>
 <div className="col-md-8 text-right">
 {/* <button type="submit" id="showAddTechDetails" onClick={() => showAddTechDetails()} className="btn btn-new"> New </button> */}
{/* Added Nitesh on 19 09 2026 */}
<button type="button" id="showAddTechDetails" onClick={() => showAddTechDetails()} className="btn btn-new">New</button>

<button
type="button"
className="btn btn-success ms-2"
onClick={openTechnicianMap}
>
View Map
</button>
{/* Start Export to excel */}
<input
    type="file"
    id="excelUpload"
    accept=".xlsx,.xls"
    style={{ display: "none" }}
    onChange={handleExcelImport}
/>

<button
    type="button"
    className="btn btn-success ms-2"
    onClick={() => document.getElementById("excelUpload").click()}
>
    Import Excel
</button>

{/* Added Nitesh on 06 10 2026 */}
<button  type="button"  className="btn btn-success ms-2" onClick={downloadSampleExcel}>
    <i className="fa-solid fa-download"></i>&nbsp; Download Sample
</button>
{/* Added Nitesh on 06 10 2026 */}


{/*End  Export to excel */}
{/* Added Nitesh on 19 09 2026 */}
  <select onChange={exportStatus} className="btn btn-primary" name="Export">
  <option value={"0"}>All</option>    
  <option value={"1"}>Active</option>  
  <option value={"2"}>Inactive</option>                
  </select>
  <select onChange={exportDownload} name="DGroup" className="btn btn-primary">
  <option value={"Download"}>Download</option>    
  <option value={"Excel"}>Excel</option>    
  <option value={"PDF"}>PDF</option>                      
  </select>


  </div>
  </div>
  </div>
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end">  
  <div class="col-sm-3 col-lg-3">
TECHNICIAN NAME
<input type="text"class="form-control" id="txtTechnicianName" maxLength="50" value={TechName} onChange={TechNamechangeHandler}/>
</div>
  <div class="col-sm-3 col-lg-2">MOBILE NUMBER <input type="text" class="form-control" tabindex="2" id="txtMobileNo"   maxlength="10" value={TechMobile} onChange={TechMobilechangeHandler}/>
  </div>    
  <div class="col-sm-4 col-lg-2">
  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
  <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
  </button></div>
  <div class="col-sm-3 col-lg-2"> </div>
  </div></div></div>
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body p-0">
  <table ref={tableRef} id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
 <thead>
<tr>
    <th style={{textAlign:"center"}}>
        S.No.
    </th>

    <th onClick={() => sorting("technicianName")} style={{textAlign:"center", cursor:"pointer"}}>
        Technician Name &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>
    <th onClick={() => sorting("mobileNumber")} style={{textAlign:"center", cursor:"pointer"}}>
        Mobile Number &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>

    <th onClick={() => sorting("email")} style={{textAlign:"center", cursor:"pointer"}} >
        Email &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>
    <th onClick={() => sorting("countryName")}
    style={{textAlign:"center", cursor:"pointer"}}>
    Country &nbsp;&nbsp;
    <i className="fa-sharp fa-solid fa-sort"></i>
</th>
<th onClick={() => sorting("stateName")}
    style={{textAlign:"center", cursor:"pointer"}}>
    State &nbsp;&nbsp;
    <i className="fa-sharp fa-solid fa-sort"></i>
</th>
    <th onClick={() => sorting("city")} style={{textAlign:"center", cursor:"pointer"}}>
        City &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>
    <th onClick={() => sorting("latitude")}
    style={{textAlign:"center", cursor:"pointer"}}>
    Latitude &nbsp;&nbsp;
    <i className="fa-sharp fa-solid fa-sort"></i>
</th>
<th onClick={() => sorting("longitude")}
    style={{textAlign:"center", cursor:"pointer"}}>
    Longitude &nbsp;&nbsp;
    <i className="fa-sharp fa-solid fa-sort"></i>
</th>
<th onClick={() => sorting("address")}
    style={{textAlign:"center", cursor:"pointer"}}>
    Address &nbsp;&nbsp;
    <i className="fa-sharp fa-solid fa-sort"></i>
</th>
    <th onClick={() => sorting("pinCode")} style={{textAlign:"center", cursor:"pointer"}}>
        PinCode &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>
    <th onClick={() => sorting("isActive")} style={{textAlign:"center", cursor:"pointer"}}>
        Status &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-sort"></i>
    </th>
    <th style={{textAlign:"center"}}> Action </th>
</tr>
</thead>
  <tbody>
  {currentPost.map((custdata,index) => {
              return (                  
              <tr key={custdata.technicianId}>
                <td style={{textAlign:"center"}}>
                {firstPost + index + 1}
            </td>
              {/* <td style={{textAlign:"center"}}>{custdata.id}</td>   */}
               
              <td>{custdata.technicianName}</td>
            <td>{custdata.mobileNumber}</td>
            <td>{custdata.email}</td>
            <td>{custdata.countryName}</td>
            <td>{custdata.stateName}</td>
            <td>{custdata.city}</td>
            <td>{custdata.latitude}</td>
            <td>{custdata.longitude}</td>
            <td>{custdata.address}</td>
            <td>{custdata.pinCode}</td>
            <td>{custdata.isActive === 1 ? "Active" : "Inactive"}</td>
              <td style={{textAlign:"center", fontSize:"16px"}}>
              <i onClick={() => showDetailsModal(custdata.technicianId)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => handleEdit(custdata.technicianId)} style={{ color:"#fd0691", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
               &nbsp;&nbsp;<i onClick={() => handleDelete(custdata.technicianId)}style={{ color:"red", cursor:'pointer'}}className="fa-solid fa-trash-can"title="Delete Technician"></i>
              </td>

              </tr>           
            );
          })}          
          </tbody>
          </table>    
          <ReactPaginate previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount} onPageChange={ChangePage} disableInitialCallback={true}  initialPage={0}  containerClassName={'pagination justify-content-end'}
          pageClassName={'page-item'}  pageLinkClassName={'page-link'}  previousClassName={'page-item'}  previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}
          breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>       
          </div> </div></div></div> 
          <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>    
    </>
    );
    }

export default TechnicianDetails;
